module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/blue-coat.9a295dc8.svg";